import React,{useState,useEffect,useCallback} from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useDB } from '../../context/DynamoDBContext';
import { getResellerBaseStationStatus, getResellerBaseStationStatus2, getResellerBaseStationStatus3,getSubscriptionsStatus, getResellerBeaconStatus, getResellerBeaconStatus2 } from '../../api/ResellerApi';
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { ResellerPageStyle } from '../../pages/Reseller/Reseller.styled';
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import Color from '../../common/ColorEnum';
import "./modalstyles.css"
import { data } from 'browserslist';
import Table from "../Table/Table"




const ViewReseller = ({ visible, setVisible,title="" }) => {
    const {dynamoDBClient}=useDB()
    const [beacons, setBeacons] = useState([])
    const [baseStation, setBaseStation] = useState([])
    const [enableApi, setEnableApi] = useState(false)
    const doc = new jsPDF()
    const [baseStationLoading, setBaseStationLoading] = useState(false)
    const [beaconLoading, setBeaconLoading] = useState(false)
    const [enableBSAPI2, setEnableBSAPI2] = useState(false)
    const [enableBSAPI3, setEnableBSAPI3] = useState(false)
    const [enableBSAPI4, setEnableBSAPI4] = useState(false)
    const queryClient = useQueryClient()
    const [enableBeaconAPI1, setEnableBeaconAPI1] = useState(false)
    const [enableBeaconAPI2, setEnableBeaconAPI2] = useState(false)
    const [enableBeaconAPI3, setEnableBeaconAPI3] = useState(false)
    const [activeBaseStations, setActiveBaseStations] = useState(0)
    const [activeBeacons, setActiveBeacons] = useState(0)
    const [subscriptions, setSubscriptions] = useState({
        total:0,
        nsm:0,
        nsy:0,
        gnm:0,
        gny:0
    })
    
    const [visited, setVisited] = useState([])
    
    const dummydata=[
        {id:"J37H32939S93",status:"Active",email:"ocufii@gmail.com",activationTime:"28-02-2023 09:44",subStatus:"Active",subType:"Standard Notification Yearly"},
        {id:"J37H32939S93",status:"InActive",email:"",activationTime:"",subStatus:"",subType:""},
        {id:"J37H32939S93",status:"InActive",email:"test@ocufii.com",activationTime:"01-01-2024 21:08",subStatus:"Expired",subType:"Standard Notification Monthly"}
    ]
    
    
    useEffect(() => {
      if(!visible){
        setBeacons([])
        setBaseStation([])
        setEnableApi(false)
        setEnableBeaconAPI1(false)
        setBaseStationLoading(false)
        setBeaconLoading(false)
        setEnableBSAPI2(false)
        setEnableBSAPI3(false)
        setEnableBSAPI4(false)
        setEnableBeaconAPI2(false)
        setEnableBeaconAPI3(false)
        setActiveBaseStations(0)
        setActiveBeacons(0)
        setSubscriptions({
            total:0,
            nsm:0,
            nsy:0,
            gnm:0,
            gny:0
        })
        setVisited([])
      }

      if(visible){
        setBaseStationLoading(true)
        setBeaconLoading(true)
        setEnableApi(true)
        setEnableBeaconAPI1(true)

      }
    }, [visible])

    
    
    const checkSubscriptionIos=(data)=>{
        if(data.subStatus!=="PROMO_EXPIRED" && data.subStatus!=="EXPIRED"){
            setSubscriptions(item=>({...item,total:item.total+1}))
            if(data.subType==="notice_service_monthly"){
                setSubscriptions(item=>({...item,nsm:item.nsm+1}))
            }

            if(data.subType==="notice_service_yearly"){
                setSubscriptions(item=>({...item,nsy:item.nsy+1}))
            }

            if(data.subType==="group_notice_service_monthly"){
                setSubscriptions(item=>({...item,gnm:item.gnm+1}))
            }

            if(data.subType==="group_notice_service_yearly"){
                setSubscriptions(item=>({...item,gny:item.gny+1}))
            }
        }
    }

    const checkSubscriptionAndroid=(data)=>{
        if(data.subStatus!=="SUBSCRIPTION_STATE_EXPIRED" && data.subStatus!=="SUBSCRIPTION_STATE_PROMO_EXPIRED" ){
            setSubscriptions(item=>({...item,total:item.total+1}))
            if(data.subId==="notice_service"){
                if(data.subType==="P1M"){
                    // monthly notification
                    setSubscriptions(item=>({...item,nsm:item.nsm+1}))
                }else{
                    // yearly notification
                    setSubscriptions(item=>({...item,nsy:item.nsy+1}))
                }
            }else{

                if(data.subType==="P1M"){
                    // monthly group notification
                    setSubscriptions(item=>({...item,gnm:item.gnm+1}))
                }else{
                    // yearly group notification
                    setSubscriptions(item=>({...item,gny:item.gny+1}))
                }
            }
        }
    }

    const countSubscriptions2=(data,check)=>{
        if(data?.subId){
            // subscription is android
            if(data.subId!==check[0].subStatus && data.subType!==check[0].subType){
                checkSubscriptionAndroid(data)
                    
            }
        }else{
            //subscription is ios
            if(data.subType!==check[0].subType){
                checkSubscriptionIos(data)
                    
            }
        }
    }

    const countSubscriptions=useCallback((data)=>{
        
        const check=visited.filter(item=>item.email===data.email)

        
        if(check.length>0){
            countSubscriptions2(data,check)
        }else{
            
            setVisited((prev)=>{
                const check2=prev.filter(item=>item.email===data.email)
                if(check2.length>0){
                    countSubscriptions2(data,check2)
                }else{
                    if(data?.subId){
                        // subscription is android
                        checkSubscriptionAndroid(data)
               
                    }else{
                        // subscription is ios
                        checkSubscriptionIos(data)
                    }
                    return [...prev,data]
                }

                return prev
            })
            
        }



    })

   
    

    const countAccount=(data)=>{
        data.forEach(element => {
            setVisited((prev)=>{
                const check=prev.filter(item=>item?.email===element?.email)
                if(check.length===0){
                    if(element?.email){
                        return [...prev,element]
                    }
                }
                return prev
            })
            

            
        });
        
    }

    const {
        status : baseStationStatus,
        data:baseStationData,
    }=useQuery({
        queryKey:["ShowTotalResellerBaseStation",title],
        queryFn:()=>getResellerBaseStationStatus(dynamoDBClient,title),
        enabled:enableApi,
        onSuccess:(response)=>{
            const data=response.baseStationList
            
            const check=response.check
            if(check){ 
                setEnableApi(false)
                setEnableBSAPI2(true)
                queryClient.fetchQuery(["ShowTotalResellerBaseStation2",title],{
                    queryFn:()=>getResellerBaseStationStatus2(dynamoDBClient,data)
                })
            }else{
                setBaseStation(data)
                setBaseStationLoading(false)
            }
            
            
        }
    })

    const {
        data:baseStation2,
    }=useQuery({
        queryKey:["ShowTotalResellerBaseStation2",title],
        queryFn:()=>getResellerBaseStationStatus2(dynamoDBClient,baseStationData.baseStationList),
        enabled:enableBSAPI2,
        onSuccess:(response)=>{
            const data=response.arr
            const check=response.check
            if(check){
                setEnableBSAPI2(false)
                setEnableBSAPI3(true)
                queryClient.fetchQuery(["ShowTotalResellerBaseStation3",title],{
                    queryFn:()=>getResellerBaseStationStatus3(dynamoDBClient,data)
                })
            }else{
                setEnableBSAPI2(false)
                setBaseStation(data)
                setBaseStationLoading(false)
            }
            
        }
    })

    const {
        data:baseStation3,
    }=useQuery({
        queryKey:["ShowTotalResellerBaseStation3",title],
        queryFn:()=>getResellerBaseStationStatus3(dynamoDBClient,baseStation2.arr),
        enabled:enableBSAPI3,
        onSuccess:(data=[])=>{
            setEnableBSAPI3(false)
            setEnableBSAPI4(true)
            queryClient.fetchQuery(["ShowTotalResellerBaseStation4",title],{
                queryFn:()=>getSubscriptionsStatus(dynamoDBClient,data)
            })
            
        }
    })
    const {
        data:baseStation4,
    }=useQuery({
        queryKey:["ShowTotalResellerBaseStation4",title],
        queryFn:()=>getSubscriptionsStatus(dynamoDBClient,baseStation3),
        enabled:enableBSAPI4,
        onSuccess:(data=[])=>{
            setBaseStation(data)
            setBaseStationLoading(false)
            setEnableBSAPI4(false)
            let noActiveAccount=true
            const count=data.reduce((acc,obj)=>{
                const isActive=obj.status==="Active" 
                if(isActive){
                    noActiveAccount=false
                    countSubscriptions(obj)
                }

                return acc + (isActive?1:0)
            },0)
            if(noActiveAccount){
                countAccount(data)
            }
            setActiveBaseStations(count)
        }
    })

    const {
        status : beaconStatus,
        data:beaconData,
    }=useQuery({
        queryKey:["showTotalResellerBeacon",title],
        queryFn:()=>getResellerBeaconStatus(dynamoDBClient,title),
        enabled:enableBeaconAPI1,
        onSuccess:(response)=>{
            const data=response.beaconList
            const check=response.check
            
            if(check){ 
                setEnableBeaconAPI1(false)
                setEnableBeaconAPI2(true)
                queryClient.fetchQuery(["showTotalResellerBeacon2",title],{
                    queryFn:()=>getResellerBeaconStatus2(dynamoDBClient,data)
                })
            }else{
                setBeaconLoading(false)
                setBeacons(data)
            }
            
        }
    })

    const {
        data:beaconData2,
    }=useQuery({
        queryKey:["showTotalResellerBeacon2",title],
        queryFn:()=>getResellerBeaconStatus2(dynamoDBClient,beaconData.beaconList),
        enabled:enableBeaconAPI2,
        onSuccess:(response)=>{
            const data=response.arr
            
            const check=response.check
            if(check){
                setEnableBeaconAPI3(true)
                queryClient.fetchQuery(["showTotalResellerBeacon3",title],{
                    queryFn:()=>getSubscriptionsStatus(dynamoDBClient,data)
                })
            }else{
                setEnableBeaconAPI2(false)
                setBeaconLoading(false)
                setBeacons(data)
            }
            
            
        }
    })

    const {
        data:beaconData3,
    }=useQuery({
        queryKey:["showTotalResellerBeacon3",title],
        queryFn:()=>getSubscriptionsStatus(dynamoDBClient,beaconData2.arr),
        enabled:enableBeaconAPI3,
        onSuccess:(data=[])=>{
            setBeacons(data)
            setBeaconLoading(false)
            setEnableBeaconAPI3(false)
            let noActiveAccount=true
            const count=data.reduce((acc,obj)=>{
                const isActive=obj.status==="Active" 
                if(isActive){
                    noActiveAccount=false
                    countSubscriptions(obj)
                }
                return acc + (isActive?1:0)
            },0)
            if(noActiveAccount){
                countAccount(data)
            }
            setActiveBeacons(count)
        }
    })
   

    const downloadpdf=()=>{
        
        
        doc.text("Ocufii Admin Portal Reseller Report",100,10,{align:"center"}).setFontSize(12).setFont("Helvetica","bold")
        doc.text(`ResellerID: ${title}`,100,20,{align:"center"}).setFontSize(12).setFont("Helvetica","bold")
        doc.setFontSize(10)
        doc.setFont("Helvetica","bold")
        doc.text(`Total Accounts: ${visited.length}`,31,30,{align:"center"}).setFontSize(10).setFont("Helvetica","bold")
        doc.text(`Total Active Subscriptions: ${subscriptions.total}`,40,40,{align:"center"}).setFontSize(10).setFont("Helvetica","normal")
        doc.text(`Standard Notification Monthly: ${subscriptions.nsm}`,47,50,{align:"center"}).setFontSize(10).setFont("Helvetica","normal")
        doc.text(`Standard Notification Yearly: ${subscriptions.nsy}`,46,60,{align:"center"}).setFontSize(10).setFont("Helvetica","normal")
        doc.text(`Group Notification Monthly: ${subscriptions.gnm}`,45,70,{align:"center"}).setFontSize(10).setFont("Helvetica","normal")
        doc.text(`Group Notification Yearly: ${subscriptions.gny}`,44,80,{align:"center"}).setFontSize(10).setFont("Helvetica","bold")
        doc.text(`Total Active Base Stations: ${activeBaseStations}`,40,90,{align:"center"}).setFontSize(10).setFont("Helvetica","bold")
        doc.text(`Total Active Beacons: ${activeBeacons}`,36,100,{align:"center"}).setFontSize(10).setFont("Helvetica","bold")
        
        const data=[]
        baseStation.forEach((element,index) => {
            data.push([index+1,element.id,element.status,element.email,element.activationTime,element.subStatus,element.plan])
        });
        const data2=[]
        beacons.forEach((element,index) => {
            data2.push([index+1,element.id,element.status,element.email,element.activationTime,element.subStatus,element.plan])
        });

        autoTable(doc, { html: '#my-table' })
        autoTable(doc, {
                head: [['#','GatewayMAC', 'Status',"Email","First Activation Time","Subscription Status","Subscription Type"]],
                body:data,
                startY:110,
                columnStyles: { text: { cellWidth: 'auto' } },
            },
        )
        autoTable(doc, {
                head: [['#','BeaconMAC', 'Status',"Email","First Activation Time","Subscription Status","Subscription Type"]],
                body:data2,
            },
        )

        doc.save('Ocufii Reseller Report.pdf')

    }
    

  return (
    <Modal show={visible} onHide={setVisible}  dialogClassName='custom-modal' size={"lg"}>
        
        <Modal.Header closeButton>
             <Modal.Title>
                View Reseller
            </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{padding:"20px 35px"}}>
            <ResellerPageStyle>
                <h3 className='modal-header2'>ResellerID: {title}</h3>
                <div className='download-div3'>

                    <Button 
                        variant="secondary" 
                        style={{backgroundColor:Color.orange,borderColor:Color.orange}} 
                        onClick={()=>downloadpdf()}
                        disabled={beaconLoading || baseStationLoading}
                    >
                        Download Report
                    </Button>
                    
                </div>
                {/* Details  */}
                <div>
                    <div className='details-div'>
                        <p className='detail-heading'>Total Accounts:&ensp;</p>
                        <p>{visited.length}</p>
                    </div>
                    <div className='details-div'>
                        <p className='detail-heading'>Total Active Subscriptions:&ensp;</p>
                        <p>{subscriptions.total}</p>
                    </div>
                    <div className='details-div2'>
                        <p className='detail-heading2'>Standard Notification Monthly:&ensp;</p>
                        <p>{subscriptions.nsm}</p>
                    </div>
                    <div className='details-div2'>
                        <p className='detail-heading2'>Standard Notification Yearly:&ensp;</p>
                        <p>{subscriptions.nsy}</p>
                    </div>
                    <div className='details-div2'>
                        <p className='detail-heading2'>Group Notification Monthly:&ensp;</p>
                        <p>{subscriptions.gnm}</p>
                    </div>
                    <div className='details-div2'>
                        <p className='detail-heading2'>Group Notification Yearly:&ensp;</p>
                        <p>{subscriptions.gny}</p>
                    </div>
                    <div className='details-div'>
                        <p className='detail-heading'>Total Active Base Stations:&ensp;</p>
                        <p>{activeBaseStations}</p>
                    </div>
                    <div className='details-div'>
                        <p className='detail-heading'>Total Active Beacons:&ensp;</p>
                        <p>{activeBeacons}</p>
                    </div>
                </div>
                {/* Tables */}
                <h5 className='text-login'>Base Stations</h5>
            
                    <Table
                        tableName={"GatewayMAC"}
                        status={baseStationLoading}
                        data={baseStation}
                    />
                <h5 className='text-login'>Beacons</h5>
                    <Table 
                        tableName={"BeaconMAC"}
                        status={beaconLoading}
                        data={beacons}
                    />
            </ResellerPageStyle>
        </Modal.Body>

        <Modal.Footer>
        
        <Button 
            variant="primary" 
            style={{backgroundColor:"red",borderColor:"red"}} 
            onClick={setVisible}
            
        >
          Close
        </Button>
            
        </Modal.Footer>
            
       
    </Modal>
  )
}

export default ViewReseller